/* ==========================================================================
   Literals > Base
   ========================================================================== */

const literals = {
    es: {},
    pt: {},
    it: {},
    de: {},
    fr: {},
    br: {},
    en: {},
    fi: {},
    mx: {},
    ru: {}
};

module.exports = function fn(language = 'es') {
    return literals[language] || {};
};
